__webpack_require__.p = "/registro/";